import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import {
  domainPrebidModulesFromDTO,
  DomainPrebidModuleSliceDTO,
  GET_DOMAIN_PREBID_MODULES,
} from './api'
import { sortToDTO } from './api/mapper'
import { Data, Variables } from './api/types'
import {
  DomainPrebidModuleSlice,
  UseGetPrebidModuleDomains,
  UseGetPrebidModuleDomainsProps,
} from './types'

export const useGetPrebidModulesDomains = ({
  filters,
  first,
  last,
  moduleType,
  sort,
  workspacePrebidModuleId,
}: UseGetPrebidModuleDomainsProps): UseGetPrebidModuleDomains => {
  const [prebidModuleDomains, setPrebidModuleDomains] = useState<DomainPrebidModuleSlice[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        domainPrebidModules: { nodes, totalCount: count },
      } = data

      if (nodes) {
        setPrebidModuleDomains(
          nodes.map(
            (domainPrebidModule: DomainPrebidModuleSliceDTO): DomainPrebidModuleSlice =>
              domainPrebidModulesFromDTO(domainPrebidModule),
          ),
        )
        setCount(count)
      }
    },
    options: {
      enabled: workspacePrebidModuleId !== undefined,
    },
    query: GET_DOMAIN_PREBID_MODULES,
    variables: {
      first,
      last,
      moduleType,
      sort: sortToDTO(sort),
      terms: filters,
      workspacePrebidModuleId: workspacePrebidModuleId!,
    },
  })

  return {
    count,
    loading,
    prebidModuleDomains,
  }
}
